import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { format, isValid } from 'date-fns';
import { formatCurrency } from '../../../../utils/formatCurrency';

/**
 * Diálogo de confirmação antes de adicionar ou atualizar lançamento avulso.
 * Exibe resumo dos dados e spinner durante o carregamento.
 */
export default function DialogConfirmarLancamento({
                                                    visible,
                                                    onHide,
                                                    onConfirm,
                                                    loading,
                                                    lancamento,
                                                    tipo = 'add',
                                                  }) {
  const titulo =
    tipo === 'add'
      ? 'Confirmar envio de lançamento'
      : 'Confirmar atualização do lançamento';

  const descricao = lancamento?.descricao || '-';
  const valor = lancamento?.valor ? formatCurrency(lancamento.valor) : 'R$ 0,00';
  const dataRef =
    lancamento?.dataRef && isValid(new Date(lancamento.dataRef))
      ? format(new Date(lancamento.dataRef), 'MM/yyyy')
      : '-';
  const vencimento =
    lancamento?.vencimento && isValid(new Date(lancamento.vencimento))
      ? format(new Date(lancamento.vencimento), 'dd/MM/yyyy')
      : '-';

  /** 🔹 Rodapé com botões e feedback visual */
  const footer = (
    <div className="flex justify-end gap-2 px-3 py-2">
      <Button
        label="Cancelar"
        icon={<FaTimes />}
        severity="danger"
        className="px-4"
        onClick={onHide}
        disabled={loading}
      />
      <Button
        label={tipo === 'add' ? 'Confirmar' : 'Atualizar'}
        icon={!loading ? <FaCheck /> : null}
        severity="success"
        className="px-4 flex items-center gap-2"
        onClick={onConfirm}
        disabled={loading}
      >
        {loading && (
          <ProgressSpinner
            style={{ width: '20px', height: '20px' }}
            strokeWidth="4"
            fill="transparent"
            animationDuration=".8s"
          />
        )}
      </Button>
    </div>
  );

  return (
    <Dialog
      header={<span className="text-lg font-semibold">{titulo}</span>}
      visible={visible}
      onHide={onHide}
      modal
      className="w-full sm:w-11/12 md:w-[420px] lg:w-[480px]"
      footer={footer}
    >
      <div className="p-4 text-sm text-gray-800 dark:text-gray-100 space-y-3 border-t border-gray-200 dark:border-gray-700">
        <div className="flex justify-between">
          <span className="font-medium text-gray-600 dark:text-gray-300">Descrição:</span>
          <span>{descricao}</span>
        </div>

        <div className="flex justify-between">
          <span className="font-medium text-gray-600 dark:text-gray-300">Valor:</span>
          <span className="font-semibold text-green-600 dark:text-emerald-400">{valor}</span>
        </div>

        <div className="flex justify-between">
          <span className="font-medium text-gray-600 dark:text-gray-300">Data referência:</span>
          <span>{dataRef}</span>
        </div>

        <div className="flex justify-between">
          <span className="font-medium text-gray-600 dark:text-gray-300">Vencimento:</span>
          <span>{vencimento}</span>
        </div>
      </div>

      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 dark:bg-gray-900/70 rounded-lg">
          <ProgressSpinner
            style={{ width: '40px', height: '40px' }}
            strokeWidth="5"
            animationDuration=".6s"
          />
        </div>
      )}
    </Dialog>
  );
}
